import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { LOGO_URL, NAV } from "../lib/site";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [menuWhite, setMenuWhite] = useState(true);

  const { pathname } = useLocation();
  const onHome = pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);

      if (!onHome) {
        setMenuWhite(false);
        return;
      }

      const element = document.elementFromPoint(window.innerWidth / 2, 90);

      if (!element) return;

      setMenuWhite(!!element.closest(".nav-dark"));
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [onHome]);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const dark = onHome && !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        dark
          ? "bg-transparent"
          : "bg-[color:var(--p10-ivory)]/85 backdrop-blur-xl border-b border-[color:var(--p10-line)]"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3">
            <img
              src={LOGO_URL}
              alt="Pay10x"
              className="h-[80px] w-auto brightness-125 "
              style={{
                filter: dark ? "brightness(1.15)" : "none",
              }}
            />
          </Link>

          <nav className="hidden lg:flex items-center gap-9">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `link-underline text-[13px] tracking-wide transition-colors duration-300 ${
                    menuWhite
                      ? "text-white hover:text-white"
                      : "text-[color:var(--p10-ink)] hover:text-[color:var(--p10-ink)]"
                  } ${isActive ? "!bg-[length:100%_1px]" : ""}`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
        
<Link
  to="/contact"
  className={`btn-square transition-all duration-300 ${
    menuWhite
      ? "!border-white !text-white hover:!bg-white hover:!text-[color:var(--p10-ink)]"
      : "!border-[color:var(--p10-ink)] !text-[color:var(--p10-ink)] hover:!bg-[color:var(--p10-ink)] hover:!text-white"
  }`}
>
  Talk to us
</Link>
            <Link
              to="/contact"
              className={`btn-square ${
                dark ? "btn-electric" : "btn-primary"
              } group`}
            >
              <span>Book a demo</span>
              <ArrowUpRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>

          <button
            onClick={() => setOpen((prev) => !prev)}
            className={`lg:hidden p-2 -mr-2 ${
              menuWhite
                ? "text-white"
                : "text-[color:var(--p10-ink)]"
            }`}
          >
            {open ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[color:var(--p10-ivory)] border-t border-[color:var(--p10-line)]">
          <div className="px-6 py-8 flex flex-col gap-5">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className="font-serif-display text-3xl text-[color:var(--p10-ink)]"
              >
                {item.label}
              </NavLink>
            ))}

            <div className="pt-4 flex flex-col gap-3">
              <Link
                to="/contact"
                className="btn-square btn-secondary"
              >
                Talk to us
              </Link>

              <Link
                to="/contact"
                className="btn-square btn-primary"
              >
                Book a demo
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}